module.exports = __webpack_public_path__ + "media/img/clients/client1-fd6b9a3f5bf6461c32695fbc20c1482e.svg";